var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAsterisk({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    className: "_dm-svg",
    focusable: "false",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.6 6.4h-3.722l2.412-2.413a.408.408 0 000-.573L12.596 1.72a.408.408 0 00-.573 0L9.6 4.143V.4c0-.22-.18-.4-.4-.4H6.8c-.22 0-.4.18-.4.4v3.732L3.985 1.718a.408.408 0 00-.573 0L1.718 3.413a.406.406 0 000 .573L4.132 6.4H.4c-.22 0-.4.18-.4.4v2.4c0 .22.18.4.4.4h3.743L1.72 12.023a.409.409 0 000 .573l1.694 1.694a.409.409 0 00.573 0L6.4 11.878V15.6c0 .22.18.4.4.4h2.4c.22 0 .4-.18.4-.4v-3.732l2.42 2.42a.408.408 0 00.573 0l1.695-1.695a.409.409 0 000-.573l-2.42-2.42H15.6c.22 0 .4-.18.4-.4V6.8c0-.22-.18-.4-.4-.4z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAsterisk);
export default __webpack_public_path__ + "static/media/Asterisk.f93e267290bb7ea2aff5dd3c2ab3130d.svg";
export { ForwardRef as ReactComponent };